// Copyright (c) 2017 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

/* eslint-disable complexity */

export async function getPipProducts(payload) {

    const endPoint = (payload.export === 'EXCEL') ? `${basePath}/pip-products/collection?export=EXCEL` : `${basePath}/pip-products/collection`;

    if (payload.accounts.length === 0) {

        return [];

    }

    const options = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return (payload.export === 'EXCEL') ? response : response.json();

    } catch (error) {

        return handleError(error);

    }

}

/* eslint-enable complexity */

export async function getDetails(pipId) {

    const endPoint = `${basePath}/pips/${pipId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getMetrics() {

    const endPoint = `${basePath}/constants?id=PIP_METRIC`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipTypes() {

    const endPoint = `${basePath}/constants?id=PIP_TYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipStatuses() {

    const endPoint = `${basePath}/constants?id=OPEN_PIP_STATUS`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getOpenPipsSummary() {

    const endPoint = `${basePath}/open-pips-summary`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipProduct(id) {

    const endPoint = `${basePath}/pip-products/${id}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function postPipCode(payload) {

    const endPoint = `${basePath}/pip-code`;

    const options = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return await response;

    } catch (error) {

        return handleError(error);

    }

}

export async function getCustomer(id, customerPrivate) {

    const endPoint = customerPrivate ?
        `${basePath}/customers/${id}?customerPrivate=${customerPrivate}` :
        `${basePath}/customers/${id}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipCodeType() {

    const endPoint = `${basePath}/constants?id=PIP_CODE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getLaborAdditivePipsSummary() {

    const endPoint = `${basePath}/labor-additive-summary`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPipProductsSearchResults(query, searchBy) {

    const endPoint = `${basePath}/pip-products/search?by=${searchBy}&q=${encodeURIComponent(query)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPipSearchResults(query, searchBy) {

    const endPoint = `${basePath}/pips/search?by=${searchBy}&q=${encodeURIComponent(query)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}



// WEBPACK FOOTER //
// ./src/pip/shared/repositories/index.js